import {post, get} from '@/lib/axios';

const activity = {
  async get_activity() {
    return get(`/activity`);
  },
};

export {activity as default};
